import {Component, OnInit, OnChanges, Input, Output, EventEmitter} from '@angular/core';
import {PropertyService} from '../../services/property.service';
import {NotificationsApiService} from '../../../../../services/api/notifications-api.service';
import {NotificationBuildingSettings} from '../../../../../types/api-response/notification';

@Component({
    selector: 'services-view',
    templateUrl: './services-view.component.html',
    styleUrls: ['./services-view.component.scss']
})
export class ServicesViewComponent implements OnInit, OnChanges {
    @Input() data;
    @Input() currentData;
    @Input() canEdit: boolean = true;
    @Output() onUpdate = new EventEmitter();
    public selectedItems = {};
    public managementServices: Object;
    public securityServices: Object;
    public residentServices: Object;
    public managementServicesKeys: Array<string>;
    public securityServicesKeys: Array<string>;
    public residentServicesKeys: Array<string>;
    public notificationBuildingSettings: NotificationBuildingSettings;

    constructor(public propertyService: PropertyService, private notificationsApiService: NotificationsApiService) {
    }

    ngOnInit() {
        this.managementServices = this.data.managementServices;
        this.securityServices = this.data.securityServices;
        this.residentServices = this.data.residentServices;
        this.managementServicesKeys = Object.keys(this.managementServices);
        this.securityServicesKeys = Object.keys(this.securityServices);
        this.residentServicesKeys = Object.keys(this.residentServices);
    }

    ngOnChanges() {
        this.createServicesModel();
    }

    update(key) {
        if (this.selectedItems[key] !== undefined) {
            this.selectedItems[key] = !this.selectedItems[key];
        } else {
            this.selectedItems[key] = true;
        }
        const selectedServices = Object.keys(this.selectedItems).filter(key => this.selectedItems[key]);

        this.onUpdate.emit(this.currentData ? {
            type: 'edit',
            data: {
                serviceIdentifier: selectedServices
            }
        } : {
            type: 'create',
            data: {
                serviceIdentifier: selectedServices
            }
        });


    }

    createServicesModel() {
        this.selectedItems = {};
        this.notificationBuildingSettings = null;
        if (this.currentData) {
            this.currentData.serviceIdentifier.forEach(item => this.selectedItems[item] = true);

            if (this.propertyService.account.isUserAdmin()) {
                this.notificationsApiService.getBuildingSettings(this.currentData.buildingId).subscribe(res => {
                    this.notificationBuildingSettings = res;
                })
            }
        }
    }

    updateNotificationSettings(notificationSettings: Partial<NotificationBuildingSettings>) {
        const data = {
            allowBanner: notificationSettings.allowBanner
        };
        this.notificationsApiService.updateBuildingSettings(this.currentData.buildingId, data).subscribe();
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/services-view/services-view.component.ts